import Wallet from "./wallet";

export default Wallet;